/**
 * created by lei lei on 2020/5/28
 * 活动动态组件
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Row, Col} from 'antd';
import {uuid} from '../../../../utils/index'
export default class ActivityTrends extends Component {
    static defaultProps = {
        showStatus: true,
        pointColor: '#BFBFBF',
        statusMark: '自定义文字',
        timeMark:""
    }
    static propTypes = {
        showStatus: PropTypes.bool, //是否显示最后的状态
        pointColor: PropTypes.string,//红点颜色
        timeMark: PropTypes.string//显示时间
    }

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }


    render() {
       let pointColor='#BFBFBF'
        if(this.props.statusMark){
            if(this.props.statusMark==='已发布'||this.props.statusMark==='已采用'){
                pointColor='#00A854'
            }
            if(this.props.statusMark==='已领取'||this.props.statusMark==='已提交 '){
                pointColor='#0E77D1'
            }
            if(this.props.statusMark==='未领取'){
                pointColor='#BFBFBF'
            }
            if(this.props.statusMark==='弃用'||this.props.statusMark==='撤回 '){
                pointColor='#ffa455'
            }
        }

        let sex = null;
        if(this.props.currentUser)
            sex = this.props.currentUser.sex;
        let photo = "images/header_boys.png";
        if(this.props.currentUser && this.props.currentUser.photoUrl && this.props.currentUser.photoUrl.length > 0){
            photo = this.props.currentUser.photoUrl
        }else{
            if(sex === 2){
                photo = "images/header_girls.png";
            }
        }

        return (
            <div  className={'ActivityTrends'}>
                <Row>
                <div style={{background:'white'}}>
                    <div style={{borderBottom:'1px solid #ebebeb',display:'flex', padding:'15px 0'}}>
                        <Col span={2}>
                            <div style={{width:'100%', height: '100%', display: 'flex', justifyContent:'center', alignItems: 'center'}}>
                                <img style={{width:40,height:40,borderRadius:'50%'}} src={photo} alt=""/>
                            </div>
                        </Col>
                       <Col span={22}>
                                <div style={{padding:'0 10px'}}>
                                    <div style={{marginTop:0}}>
                                       {/* 删除内容... display:'-webkit-box', overflow: 'hidden', WebkitLineClamp:1,WebkitBoxOrient:'vertical',*/}
                                       <span style={{maxHeight: '47px',  paddingBottom: 5}}>
                                        {this.props.dataSourrce&&this.props.dataSourrce.length>0&&this.props.dataSourrce.map((item,i)=>{
                                        if(typeof item==='string'){
                                            return(
                                                    <span key={uuid()} style={{fontWeight:'bold'}}>{item}&nbsp;</span>
                                                )

                                        }
                                        if(typeof item==='object'){
                                                    if(item.color){
                                                        return(
                                                                <span key={uuid()} style={{color:item.color,fontWeight:'bold'}}>{item.text}&nbsp;</span>
                                                            )
                                                    }
                                                    if (item.param){
                                                        return(
                                                            <span key={uuid()} onClick={()=>{this.props.onClickItem&&this.props.onClickItem(item.param)}} style={{fontWeight:'bold',cursor:'pointer',color:'#175199'}} title={item.text}>{item.text}&nbsp;</span>
                                                        )
                                                    }
                                        }
                                    })

                                }</span>
                                <span style={{ color: '#999999'}}>{this.props.timeMark}</span>
                                    </div>
                                </div>
                       </Col>
                      {/* <Col span={5}>
                          <div style={{fontSize:12,color:'#0000003e',marginTop:5,marginLeft:10}}>{this.props.timeMark}</div>
                          {this.props.showStatus?  <div style={{display:'-webkit-inline-box',marginTop:10}}>
                             <div style={{width:8,height:8,background:this.props.pointColor,borderRadius:'50%',marginTop:7,marginLeft:10}}/>
                              <div style={{height:20,lineHeight:'20px',fontSize:12,color:'#ffff',marginLeft:10,width:54, textAlign:"center", right:0,background:pointColor,borderRadius:10,}}>{this.props.statusMark}</div>
                          </div>:null}
                      </Col> */}
                    </div>
                </div>
                </Row>
            </div>
        )
    }

}